import { Box, Tag, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import PlannedBreaks from 'modules/shift_management/components/ShiftManagement/PlannedBreaks'
import type UnassignedShift from 'modules/shift_management/store/internal/models/UnassignedShift'
import type PlannedBreak from 'modules/time_planning/store/internal/models/PlannedBreak'

interface Props {
  unassignedShift: UnassignedShift
  plannedBreaks: PlannedBreak[]
}

const Content = ({ unassignedShift, plannedBreaks }: Props) => {
  const timeStart = unassignedShift.startTime
  const timeEnd = unassignedShift.endTime

  return (
    <Box flexDirection="column" gap="s24">
      <Box gap="s8">
        <Text size="200" color="grey800">
          {i18n.t('shift_management.coverage_section.unassigned_shift.amount_employees')}
        </Text>
        <Box flexDirection="row" gap="s8">
          <Text size="300" color="grey1000">
            {unassignedShift.counter}
          </Text>
        </Box>
      </Box>
      <Box gap="s8">
        <Text size="200" color="grey800">
          {i18n.t('shift_management.shift_details_modal.start_end_times')}
        </Text>
        <Box flexDirection="row" gap="s8">
          <Tag>
            {timeStart} - {timeEnd}
          </Tag>
          {unassignedShift.overnightShift && (
            <Box paddingX="s2">
              <Tag>{i18n.t('shift_management.plus_1_day_tag')}</Tag>
            </Box>
          )}
        </Box>
        {unassignedShift.extraHours && (
          <Box flexDirection="row">
            <Tag type="viridian">{i18n.t('shift_management.overtime_tag')}</Tag>
          </Box>
        )}
      </Box>
      {!!plannedBreaks.length && <PlannedBreaks plannedBreaks={plannedBreaks} canManage />}
      {!!unassignedShift.locationId && (
        <Box gap="s8">
          <Text size="200" color="grey800">
            {i18n.t('shift_management.shift_details_modal.workplace')}
          </Text>
          <Text size="300" color="grey1000">
            {unassignedShift.location?.attributes.name}
          </Text>
        </Box>
      )}
      {!!unassignedShift.workAreaId && (
        <Box gap="s8">
          <Text size="200" color="grey800">
            {i18n.t('shift_management.shift_details_modal.workarea')}
          </Text>
          <Text size="300" color="grey1000">
            {unassignedShift.workArea?.attributes.name}
          </Text>
        </Box>
      )}
      {!!unassignedShift.notes && (
        <Box gap="s8">
          <Text size="200" color="grey800">
            {i18n.t('shift_management.shift_details_modal.comments')}
          </Text>
          <Text size="300" color="grey1000">
            {unassignedShift.notes}
          </Text>
        </Box>
      )}
    </Box>
  )
}

export default observer(Content)
